"use client"

import dynamic from "next/dynamic"

const HomeMobileControl = dynamic(
  () =>
    import("@/features/home/components/home-mobile-control").then(
      (mod) => mod.HomeMobileControl
    ),
  {
    ssr: false,
  }
)

export function MobileControl() {
  return <HomeMobileControl />
}
